import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  height: calc(100vh - 260px);
  overflow: auto;

  display: flex;
  flex-direction: column;
  gap: 1rem;
`
